var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('address',[_vm._l((_vm.$props.lines),function(line){return [_vm._v("\n    "+_vm._s(line)+"\n  ")]}),_vm._v("\n\n  "+_vm._s(_vm.$props.locality)+" "+_vm._s(_vm.$props.postalCode)+" "+_vm._s(_vm.$props.country)+"\n")],2)}
var staticRenderFns = []

export { render, staticRenderFns }